/* eslint-disable jira/import-whitelist */
import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { MENU_ID_PROJECTS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { getInitialSelectedPath } from '@jira/navigation-apps__sidebar-nav4-context/src/common/utils/selected-path/getInitialSelectedPath.tsx';
import { isSelectedPath } from '@jira/navigation-apps__sidebar-nav4-context/src/common/utils/selected-path/isSelectedPath.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type CsmAppSidebarQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/__generated__/CsmAppSidebarQuery.graphql';

export const csmAppSidebarQueryResource: RouteResource<
	PreloadedQuery<CsmAppSidebarQuery, Record<string, unknown>>
> = createRelayResource<CsmAppSidebarQuery>({
	type: 'CSM_APP_SIDEBAR_QUERY_RESOURCE',
	getQuery: (routerContext, { tenantContext: { cloudId } }) => {
		const initialSelectedPath = getInitialSelectedPath(routerContext);

		return {
			parameters: QUERY,
			variables: {
				cloudId,
				isProjectsExpanded: isSelectedPath(initialSelectedPath, MENU_ID_PROJECTS),
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});
